module.exports = __webpack_public_path__ + "img/03-tittle-01.e4d57b07.png";